import { useLogout as useXsLogout } from "@xinosolutions/xs-auth-react";
import { postLogoutAssociate } from "../lib/api";
import { useProductMember } from "../context/ProductContext";

/**
 * Same logout shape as xs-template-web-app: XS Auth sign-out + best-effort member_logout.
 * Exposes `logout` / `signOut` for ShellAccountActions and other call sites.
 */
export function useAdminLogout({ homePath = "/" } = {}) {
  const { clearProduct } = useProductMember();

  const { signOut, pending } = useXsLogout({
    homePath,
    onRevokedAll: () => {
      clearProduct();
      void postLogoutAssociate();
    },
    onRestored: () => {
      void postLogoutAssociate().catch(() => {});
    },
  });

  return { logout: signOut, signOut, pending };
}
